<script>

export default {
  name: "coPaymentInputs",
  props: {
    coPaymentData: Object,
    insuranceProviderError: Boolean,
    OOPAmountError: Boolean,
    InsAmountError: Boolean,
    inputsDisabled: Boolean
  },
  data() {
    return {
      coPaymentDataVal: {
        coPaymentOOPCurrency: 'USD',
        coPaymentOOPAmount: 0,
        coPaymentInsCurrency: 'USD',
        coPaymentInsAmount: 0,
        insuranceProvider: ''
      },

    }
  },
  methods: {
    decimalNumbersAllowed(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
  },
  watch: {
    coPaymentDataVal: {
      handler(newValue) {
        let vm = this;
        vm.$emit('coPaymentDataVal', newValue);
      },
      deep: true
    },
    coPaymentData: {
      handler(newValue) {
        let vm = this;
        vm.coPaymentDataVal.coPaymentOOPCurrency = newValue.coPaymentOOPCurrency
        vm.coPaymentDataVal.coPaymentOOPAmount = newValue.coPaymentOOPAmount
        vm.coPaymentDataVal.coPaymentInsCurrency = newValue.coPaymentInsCurrency
        vm.coPaymentDataVal.coPaymentInsAmount = newValue.coPaymentInsAmount
        vm.coPaymentDataVal.insuranceProvider = newValue.insuranceProvider
      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="column is-one-third has-text-left right-border-input bottom-border-input-mobile">
    <label class="label has-text-centered">Co-Payment (Out of pocket)</label>
    <div class="field has-addons">
      <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="coPaymentDataVal.coPaymentOOPCurrency">
                    <option value="USD">USD</option>
                    <option value="KES">KES</option>
                    <option value="UGX">UGX</option>
                    <option value="TSH">TSH</option>
                    <option value="ETB">ETB</option>
                    <option value="MWK">MWK</option>
                  </select>
                </span>
      </p>
      <p class="control is-expanded">
        <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="number"
               placeholder="Co-payment Amount"
               v-bind:class="{'error-input':OOPAmountError}"
               v-model.number="coPaymentDataVal.coPaymentOOPAmount"
               v-on:keydown="decimalNumbersAllowed">
      </p>
    </div>
  </div>
  <div class="column is-one-third has-text-left right-border-input bottom-border-input-mobile">
    <label class="label has-text-centered">Co-Payment (Insurance)</label>
    <div class="field has-addons">
      <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="coPaymentDataVal.coPaymentInsCurrency">
                    <option value="USD">USD</option>
                    <option value="KES">KES</option>
                    <option value="UGX">UGX</option>
                    <option value="TSH">TSH</option>
                    <option value="ETB">ETB</option>
                    <option value="MWK">MWK</option>
                  </select>
                </span>
      </p>
      <p class="control is-expanded">
        <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="number"
               placeholder="Co-payment Amount"
               v-bind:class="{'error-input':InsAmountError}"
               v-model.number="coPaymentDataVal.coPaymentInsAmount"
               v-on:keydown="decimalNumbersAllowed">
      </p>
    </div>
  </div>
  <div class="column is-one-third has-text-left ">
    <label class="label has-text-centered">Insurance Provider</label>
    <div class="field">
      <p class="control is-expanded has-icons-left">
        <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
               placeholder="Insurance Provider"
               v-bind:class="{'error-input':insuranceProviderError}"
               v-model="coPaymentDataVal.insuranceProvider">
        <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'umbrella']"/>
                </span>
      </p>
    </div>
  </div>
</template>

<style scoped>
.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
}

@media screen and (min-width: 769px) {
  .bottom-border-input-mobile {
    border-bottom: none;
  }

  .right-border-input {
    border-right: 1px solid black;
  }
}

@media screen and (max-width: 768px) {

  .field.has-addons,
  .field.is-grouped {
    display: block !important;

    .control:not(:last-child) {
      margin-right: 0 !important;
      margin-bottom: 1em !important;

      button {
        width: 100% !important;
      }
    }
  }

  .right-border-input {
    border-right: none;
  }

  .bottom-border-input-mobile {
    border-bottom: 1px solid black;
  }
}

</style>